import { render, staticRenderFns } from "./ProofForm.vue?vue&type=template&id=daa6e49a&lang=pug"
import script from "./ProofForm.vue?vue&type=script&lang=js"
export * from "./ProofForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports